export default "__VITE_ASSET__DxnAL4gF__";